
import { Component, Vue } from 'vue-property-decorator';
import Layer from '@/components/service/InsLayer.vue';
import { FrontE } from '@/sdk/common/SysConst';
@Component({
  components: {
    Layer
  }
})
export default class App extends Vue {
  fontLoadPromise: any = null;

  async loadCustomFont() {
      // 已有正在執行/已完成任務，直接複用
      if (this.fontLoadPromise) {
        return this.fontLoadPromise;
      }
      // 檢查是否支援 document.fonts
      if (!('fonts' in document)) return;

      const loadPromise = (async () => {
        try {
          // 動態建立link載入font.css
          const link = (document as any).createElement('link');
          link.rel = 'stylesheet';
          link.href = '/static/css/font.css';
          (document as any).head.appendChild(link);

          // 等待document全部字型載入完成
          await (document as any).fonts.ready;
          console.log('font.css 內字型載入完畢');
        } catch (err) {
          console.warn('字型載入異常：', err);
          // 失敗清空，允許下次重試
          this.fontLoadPromise = null;
        }
      })();

      this.fontLoadPromise = loadPromise;
      return loadPromise;
    }

  mounted() {
    Vue.prototype.$ShowLayer();
    setTimeout(() => {
      Vue.prototype.$HiddenLayer();
    }, 2000);

    // 等瀏覽器閒置時再載入字體
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(() => {
        this.loadCustomFont();
      });
    } else {
      // 備用，延遲 1秒
      setTimeout(() => {
        this.loadCustomFont();
      }, 1000);
    }
  }
  beforeUpdate() {
    if (this.$route.name !== 'home') {
      return;
    }
    if (this.$route.query.returnUrl) {
      let url = this.$route.query.returnUrl + '?';
      Object.keys(this.$route.query).forEach(e => {
        if (e !== 'returnUrl') url += e + '=' + this.$route.query[e] + '&';
      });
      this.$router.push(url);
    } else {
      this.$nextTick(() => {
        this.$Api.promotion.GetHomeSeoData().then(result => {
          document.title = result.Data.Title;
        });
      });
    }
  }
  beforeCreate() {
    if (
      ((Vue.prototype.userAgent === 'mobile' && FrontE.mobileBuilding) ||
        (Vue.prototype.userAgent === 'pc' && FrontE.pcBuilding)) &&
      this.$route.name !== 'building'
    ) {
      this.$router.push('/building');
    }
    if (!window['MemberApi']) window['MemberApi'] = this.$Api.member;

    // 連接FB
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.setAttribute('rel', 'preload');
    let local = this.$Storage.get('locale') || this.FrontE.defaultLang;
    let lang = {
      E: 'en_US',
      S: 'zh_CN',
      C: 'zh_HK'
    };
    s.src =
      'https://connect.facebook.net/' +
      lang[local] +
      '/sdk.js#xfbml=1&version=v3.0';
    document.body.appendChild(s);
  }
}
